import { ChangeEvent } from "react";

const birthDateFormater = (input: HTMLInputElement) => {
  if (!/\D/.test(input.value)) {
    const value = input.value;
    if (value.length === 8) {
      input.value = `${value.slice(0, 2)}/${value.slice(2, 4)}/${value.slice(4, 8)}`;
    }
  } else {
    input.value = "";
  }
};

export const birthDateMask = (event: ChangeEvent<HTMLInputElement>) => {
  if (event.target instanceof HTMLInputElement) {
    birthDateFormater(event.target);
  }
};
